import axios from './base'

// 首页概览 API（后端 app/Controller/HomeController，路由 /home）
// 首页统计卡 + 最新预约；图表类数据在 /report（见 api/report.js）
// 数据按企业隔离：主账号（超管 is_super=1 或主公司 company_id=1）看全部，其余企业账号只看本公司及下级

// 顶部统计卡（注册用户 / 今日预约 / 实名待审 / 核销成功 / 社区帖子 / 进行中活动）
// 返回 { cards: [{ key, label, value }], updated_at }，key 用于前端映射图标与配色
export function getHomeOverview() {
  return axios.request({
    url: '/home/overview',
    method: 'get',
  })
}

// 最新预约（默认最近 6 条，含 type_text / status_text / service_name / service_position）
export function getLatestAppointments() {
  return axios.request({
    url: '/home/latest-appointments',
    method: 'get',
  })
}
